export const GET_CONFIG_DETAILS = "GET_CONFIG_DETAILS";
